import { buildGithubTrendingGateMarkup } from './githubTrendingGateMarkup';
import { buildGithubTrendingUnlockedMarkup } from './githubTrendingUnlockedMarkup';

/**
 * GitHub Trending panel inner content — shared between two mount points:
 *
 * 1. The PC top-level `#view-github-trending` view (wrapped in shellMarkup.ts).
 * 2. The mobile Social aggregate's `.social-panel` (github sub-tab
 *    inside `#view-social`, wrapped in socialMarkup.ts).
 *
 * Every mount gets unique DOM ids for accessibility and test selectors,
 * while `data-gh-role` is the stable component contract used by runtime
 * hydration. This keeps the two view instances independent without making
 * the hydrator depend on instance-specific ids.
 */
function buildGithubTrendingMarkup(mount: 'desktop' | 'social'): string {
	const social = mount === 'social';
	const idSuffix = social ? 'Social' : '';
	const subscriptionPrefix = social ? 'ghGateSocial' : 'ghGate';
	return String.raw`<div class="gh-trending-mount" data-gh-mount="${mount}">
${buildGithubTrendingGateMarkup({ idSuffix, subscriptionPrefix })}

${buildGithubTrendingUnlockedMarkup(idSuffix)}
</div>`;
}

export const githubTrendingMarkup = buildGithubTrendingMarkup('desktop');
export const githubTrendingSocialMarkup = buildGithubTrendingMarkup('social');
